import { convert } from "html-to-text";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { ImArrowRight2 } from "react-icons/im";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Title, { TitleHeader } from "../../sharedComponents/Title";
import { useLocal } from "../../App";
import { getGermanMonths } from "../../utils";
import DeadlinePreviewModal from "./DeadlinePreviewModal";

const DeadlinesListSection = ({ sidebars, title, details, isSidebar }) => {
  const intl = useIntl();
  const local = useLocal();
  const isMainLoading = useSelector(
    (state) => state.postsDetails.isMainLoading
  );

  const [deadlines, setDeadlines] = useState(details);
  const [deadlinesList, setDeadlinesList] = useState();
  const [calenderDeadlinesList, setCalenderDeadlinesList] = useState();
  const [previewDeadline, setPreviewDeadline] = useState();
  const [showDeadlineModal, setShowDeadlineModal] = useState(false);
  const [highlightedDates, setHighlightedDates] = useState();
  const [clickedDateData, setClickedDateData] = useState();
  const [showClickedDateDeadline, setShowClickedDateDeadline] = useState(false);
  const [filteredDeadlines, setFilteredDeadlines] = useState();
  const [colorChange, setColorChange] = useState(false);
  const [month, setMonth] = useState(new Date());
  const [topOffset, setTopOffset] = useState();

  useEffect(() => {
    let navAll = document.querySelectorAll(".rdp-nav");

    const closeDetailModal = () => {
      setShowClickedDateDeadline(false);
    };

    navAll.forEach((item) => {
      item?.addEventListener("click", closeDetailModal);
    });
    return () => {
      navAll.forEach((item) => {
        item?.removeEventListener("click", closeDetailModal);
      });
    };
  }, [showClickedDateDeadline]);

  useEffect(() => {
    setDeadlines(details);
  }, [details]);

  const getDatesByDisplayOption = (deadlinesData, type) => {
    let data = deadlinesData
      ?.filter((item) => item?.date !== null)
      .filter((item) => {
        if (deadlines?.display_option === "all") {
          return item;
        } else if (deadlines?.display_option === "past") {
          const today = new Date();
          return new Date(item?.date) < today;
        } else if (deadlines?.display_option === "future") {
          const today = new Date();
          return (
            new Date(item?.date) > today ||
            item?.date === moment(new Date()).format("YYYY-MM-DD")
          );
        } else if (deadlines?.display_option === "current_next") {
          const currentYear = moment().format("YYYY");
          const nextYear = moment().add(1, "year").format("YYYY");
          if (type === "list") {
            const today = new Date();
            return (
              (new Date(item?.date) > today &&
                moment(item?.date).format("YYYY") === currentYear) ||
              item?.date === moment(new Date()).format("YYYY-MM-DD") ||
              moment(item?.date).format("YYYY") === nextYear
            );
          } else {
            return (
              moment(item?.date).format("YYYY") === currentYear ||
              item?.date === moment(new Date()).format("YYYY-MM-DD") ||
              moment(item?.date).format("YYYY") === nextYear
            );
          }
        } else {
          return null;
        }
      });

    return data;
  };

  const filterByVariant = (arr) => {
    let data = arr?.filter((item) => {
      if (
        deadlines?.display_variant === "year" &&
        deadlines?.display_option === "current_next"
      ) {
        return item;
      } else if (
        deadlines?.display_variant === "month" &&
        deadlines?.display_option === "current_next"
      ) {
        const currentMonth = moment().format("M");
        const nextMonth = moment().add(1, "month").format("M");
        const currentYear = moment().format("YYYY");
        return (
          (moment(item?.date).format("M") === currentMonth &&
            moment(item?.date).format("YYYY") === currentYear) ||
          (moment(item?.date).format("M") === nextMonth &&
            moment(item?.date).format("YYYY") === currentYear)
        );
      } else if (deadlines?.display_variant === "year") {
        return moment(item?.date).format("YYYY") === moment().format("YYYY");
      } else if (deadlines?.display_variant === "month") {
        return (
          moment(item?.date).format("M") === moment().format("M") &&
          moment(item?.date).format("YYYY") === moment().format("YYYY")
        );
      } else {
        return null;
      }
    });
    return data;
  };

  const groupDataByMonth = (data) => {
    const arr2 = [...data];
    const sorted = arr2.sort((a, b) => {
      if (deadlines?.group_by_month === 1) {
        return new Date(a?.date) - new Date(b?.date);
      } else {
        return null;
      }
    });

    const groupBy = new Map();
    const arr3 = [...sorted];
    arr3?.forEach((item) => {
      const year = new Date(item?.date).getFullYear();
      const month = new Date(item?.date).getMonth();

      const yearKey = `${year}-${month}`;

      if (groupBy.has(yearKey)) {
        groupBy.get(yearKey).push(item);
      } else {
        groupBy.set(yearKey, [item]);
      }
    });

    const final = [];
    groupBy.forEach((monthItems, yearKey) => {
      const [year] = yearKey.split("-").map(Number);
      final.push({ year, items: monthItems });
    });

    return final;
  };

  useEffect(() => {
    const tempObj = { ...deadlines };
    const deadlinesDisplayOption = getDatesByDisplayOption(
      tempObj?.deadlines,
      "list"
    );
    const calenderDeadlinesDisplayOption = getDatesByDisplayOption(
      tempObj?.deadlines,
      "calender"
    );

    const arr = [...deadlinesDisplayOption];
    const calenderArr = [...calenderDeadlinesDisplayOption];
    const filtered = filterByVariant(arr);
    const calenderFiltered = filterByVariant(calenderArr);

    setFilteredDeadlines(filtered);
    const final = groupDataByMonth(filtered);
    const calenderFinal = groupDataByMonth(calenderFiltered);

    setDeadlinesList(final);
    setCalenderDeadlinesList(calenderFinal);
  }, [deadlines]);

  useEffect(() => {
    let filteredDates = calenderDeadlinesList
      ?.flatMap((item) => item?.items || [])
      .map((item) => item?.date);
    const highlighted = filteredDates?.map((date) => new Date(date));
    setHighlightedDates(highlighted);
  }, [calenderDeadlinesList]);

  const closeModal = () => {
    setShowDeadlineModal(false);
  };

  const handleDayClick = (day) => {
    const selectedCells = document.querySelectorAll(".rdp-day_selected");
    const cellsArr = Array.from(selectedCells);
    const clickedCell = cellsArr.filter(
      (item) => item.innerText === moment(day).format("D")
    );

    if (clickedCell && clickedCell.length > 0) {
      const top = clickedCell[0].offsetTop;
      setTopOffset(top);
    }

    const selectedDay = moment(day).format("YYYY-MM-DD");
    const arr = calenderDeadlinesList
      ?.flatMap((item) => item?.items || [])
      ?.filter((item) => item?.date === selectedDay);
    setClickedDateData(arr);
    setShowClickedDateDeadline(!showClickedDateDeadline);
  };

  useEffect(() => {
    let deadlineCalender = document?.getElementById(
      `deadlines_calender_${details?.id}`
    );
    if (calenderDeadlinesList && deadlineCalender) {
      let func = () => {
        let flattened = calenderDeadlinesList?.flatMap(
          (item) => item?.items || []
        );
        const selectedCells = deadlineCalender?.querySelectorAll(
          ".rdp-day_selected"
        );

        const cellsArr = Array.from(selectedCells);
        flattened?.forEach((item) => {
          cellsArr?.forEach((cell) => {
            if (
              moment(new Date(item?.date)).format("D") === cell.innerText &&
              moment(month).month() === moment(new Date(item?.date)).month()
            ) {
              cell.style.backgroundColor = flattened
                .filter((val, i) => val?.date === item?.date)
                .every(
                  (value, i, array) =>
                    value?.deadline_group?.color ===
                    array[0]?.deadline_group?.color
                )
                ? item?.deadline_group?.color
                : deadlines?.multi_color_deadlines;
            }
          });
        });
      };
      func();
    }
  }, [calenderDeadlinesList, highlightedDates, colorChange]);

  const navigationMenu = useSelector(
    (state) => state.navigationMenu.navigationMenu
  );
  const [navigateTo, setNavigateTo] = useState([]);

  useEffect(() => {
    if (
      navigationMenu.length !== 0 &&
      Object.keys(navigationMenu).length !== 0
    ) {
      const removeNested = (nav) => {
        let children = [];
        return nav
          .map((m) => {
            if (m.children && m.children.length) {
              children = [...children, ...m.children];
            }
            return m;
          })
          .concat(children.length ? removeNested(children) : children);
      };

      const filtered = (removeNested(navigationMenu) || []).filter(
        (item) => item.id === details?.header_navigation_id
      );

      setNavigateTo(filtered);
    }
  }, [details?.header_navigation_id]);

  useEffect(() => {
    let deadlineCalender = document?.getElementById(
      `deadlines_calender_${details?.id}`
    );

    const func = (e) => {
      const isDeadline = deadlineCalender.contains(e.target);
      if (!isDeadline) {
        setShowClickedDateDeadline(false);
      }
    };
    if (showClickedDateDeadline) {
      document.addEventListener("click", (e) => func(e));
      return () => {
        document.removeEventListener("click", (e) => func(e));
      };
    }
  }, [showClickedDateDeadline]);

  return (
    <>
      {showDeadlineModal && (
        <DeadlinePreviewModal
          show={showDeadlineModal}
          closeModal={closeModal}
          previewDeadline={previewDeadline}
        />
      )}
      {!isSidebar ? (
        <div>
          {deadlines?.display_header ? (
            sidebars && Object.entries(sidebars).length > 0 ? (
              <TitleHeader title={title} noMarginTop />
            ) : (
              <Title title={title} />
            )
          ) : null}
          <div
            className={`${
              sidebars && Object.entries(sidebars).length === 0
                ? "container"
                : "container p-0"
            }`}
          >
            {deadlines?.group_by_month === 0 ? (
              <div className="d-flex flex-wrap pt-3">
                {filteredDeadlines && filteredDeadlines.length > 0 ? (
                  filteredDeadlines.map((deadline, i) => {
                    return (
                      <div
                        key={i}
                        className={`cursor-pointer ${
                          sidebars && Object.entries(sidebars).length === 0
                            ? "d-flex col-md-12 mb-4 px-4"
                            : "d-flex col-md-12 mb-4"
                        }`}
                        onClick={() => {
                          setPreviewDeadline(deadline);
                          setShowDeadlineModal(true);
                        }}
                      >
                        <div
                          className=""
                          style={{
                            maxHeight: "70px",
                            maxWidth: "58px",
                          }}
                        >
                          <div
                            className=" text-white px-3 d-flex justify-content-center"
                            style={{
                              backgroundColor:
                                deadline?.deadline_group &&
                                Object.entries(deadline?.deadline_group)
                                  .length > 0
                                  ? deadline?.deadline_group.color
                                  : "var(--accent-color)",
                              borderRadius: "4px 4px 0 0",
                            }}
                          >
                            <span className="fw-bold">
                              {local && local === "en"
                                ? deadline?.date
                                  ? moment(deadline?.date).format("MMM")
                                  : "-"
                                : deadline?.date
                                ? getGermanMonths(deadline?.date)
                                : "-"}
                            </span>
                          </div>
                          <div
                            className="d-flex flex-column align-items-center border border-top-0"
                            style={{
                              borderRadius: "0 0 4px 4px",
                              backgroundColor: "#f8f8f8",
                            }}
                          >
                            <span className="fw-bold">
                              {deadline?.date
                                ? moment(deadline?.date).format("DD")
                                : "-"}
                            </span>
                            <span style={{ fontSize: "10px" }}>
                              {deadline?.date
                                ? moment(deadline?.date).format("YYYY")
                                : "-"}
                            </span>
                          </div>
                        </div>
                        <div className="px-4 d-flex flex-column w-100">
                          <h3 className="deadline_title">{deadline?.title}</h3>
                          {deadline?.description ? (
                            <div className="deadline_description">
                              {convert(deadline?.description)}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div>
                    <p className="text-center py-4">
                      {intl.formatMessage({ id: "NO_DATA" })}
                    </p>
                  </div>
                )}
              </div>
            ) : (
              <div>
                {deadlinesList && deadlinesList.length > 0 ? (
                  deadlinesList.map((item, i) => {
                    return (
                      <div key={i}>
                        <div className="d-flex flex-wrap">
                          {item.items.map((deadline, deadlineIndex) => {
                            return (
                              <React.Fragment key={`index_${deadlineIndex}`}>
                                {deadlinesList?.[i]?.year !==
                                  deadlinesList?.[i - 1]?.year &&
                                  deadlineIndex === 0 && (
                                    <h5 className="my-0 pb-3 fw-bold">
                                      {deadlinesList?.[i]?.year}
                                    </h5>
                                  )}
                                <div
                                  className={`cursor-pointer ${
                                    sidebars &&
                                    Object.entries(sidebars).length === 0
                                      ? "d-flex col-md-12 mb-4 px-4"
                                      : "d-flex col-md-12 mb-4"
                                  }`}
                                  onClick={() => {
                                    setPreviewDeadline(deadline);
                                    setShowDeadlineModal(true);
                                  }}
                                >
                                  <div
                                    className=""
                                    style={{
                                      maxHeight: "70px",
                                      maxWidth: "58px",
                                    }}
                                  >
                                    <div
                                      className="text-white px-3 d-flex justify-content-center"
                                      style={{
                                        backgroundColor:
                                          deadline?.deadline_group &&
                                          Object.entries(
                                            deadline?.deadline_group
                                          ).length > 0
                                            ? deadline?.deadline_group.color
                                            : "var(--accent-color)",
                                        borderRadius: "4px 4px 0 0",
                                      }}
                                    >
                                      <span className="fw-bold">
                                        {local && local === "en"
                                          ? deadline?.date
                                            ? moment(deadline?.date).format(
                                                "MMM"
                                              )
                                            : "-"
                                          : deadline?.date
                                          ? getGermanMonths(deadline?.date)
                                          : "-"}
                                      </span>
                                    </div>
                                    <div
                                      className="d-flex flex-column align-items-center border border-top-0"
                                      style={{
                                        borderRadius: "0 0 4px 4px",
                                        backgroundColor: "#f8f8f8",
                                      }}
                                    >
                                      <span className="fw-bold">
                                        {deadline?.date
                                          ? moment(deadline?.date).format("DD")
                                          : "-"}
                                      </span>
                                      <span style={{ fontSize: "10px" }}>
                                        {deadline?.date
                                          ? moment(deadline?.date).format(
                                              "YYYY"
                                            )
                                          : "-"}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="px-4 d-flex flex-column w-100">
                                    <h3 className="deadline_title">
                                      {deadline?.title}
                                    </h3>
                                    {deadline?.description ? (
                                      <div className="deadline_description">
                                        {convert(deadline?.description)}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })}
                        </div>

                        {i === deadlinesList?.length - 1 ? null : (
                          <div
                            className="mb-3"
                            style={{
                              height: "2px",
                              backgroundColor: "#eeeeee",
                            }}
                          ></div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div>
                    <p className="text-center py-4">
                      {intl.formatMessage({ id: "NO_DATA" })}
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="deadlines-wrapper  mb-3">
          {Boolean(details?.display_header) ? (
            <Link to={`/${navigateTo[0]?.seo_permalink}`}>
              <h4 className="border-section">{details?.title}</h4>
            </Link>
          ) : null}
          <div className="position-relative" id="calenderParent">
            {showClickedDateDeadline && clickedDateData?.length > 0 && (
              <div
                className="position-absolute shadow-sm pb-2"
                style={{
                  backgroundColor: "white",
                  zIndex: "3",
                  left: 0,
                  right: 0,
                  margin: "0 auto",
                  minWidth: "100px",
                  maxWidth: "300px",
                  top: topOffset + 36 + "px",
                  border: "1px solid var(--accent-color)",
                }}
              >
                {clickedDateData &&
                  clickedDateData.length > 0 &&
                  clickedDateData.map((item, i) => {
                    return (
                      <React.Fragment key={i}>
                        <div
                          className="px-2 py-3 d-flex flex-column align-items-center"
                          style={{
                            height: "fit-content",
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-between pb-2 px-2 gap-2 w-100">
                            <div className="">
                              <span
                                className={`${
                                  item?.description
                                    ? "deadline_detail_title"
                                    : "deadline_detail_title_without_desc"
                                } fw-bold`}
                              >
                                {item.title}
                              </span>
                            </div>
                          </div>
                          <div
                            className={`d-flex gap-1 align-items-start justify-content-start w-100 px-2 ${
                              item?.description
                                ? "deadline_detail_description_div cursor-pointer"
                                : ""
                            }`}
                            onClick={() => {
                              if (item?.description) {
                                setPreviewDeadline(item);
                                setShowClickedDateDeadline(false);
                                setShowDeadlineModal(true);
                                setClickedDateData([]);
                              } else {
                                return;
                              }
                            }}
                          >
                            <span>
                              <ImArrowRight2
                                style={{
                                  fontSize: "12px",
                                  color: item?.deadline_group?.color
                                    ? item.deadline_group.color
                                    : "gray",
                                }}
                              />
                            </span>
                            <span
                              className={`align-self-center deadline_detail_description ${
                                item?.description
                                  ? "deadline_detail_description_div"
                                  : ""
                              } `}
                              style={{ color: item?.description ? "" : "gray" }}
                            >
                              {item?.description
                                ? convert(item?.description)
                                : intl.formatMessage({
                                    id:
                                      "DEADLINE_CALENDER_DETAIL_NO_DESCRIPTION",
                                  })}
                            </span>
                          </div>
                        </div>
                        {clickedDateData.length > 1 &&
                          i !== clickedDateData.length - 1 && (
                            <div
                              className="mx-3"
                              style={{
                                height: "1px",
                                backgroundColor: "#eeeeee",
                              }}
                            ></div>
                          )}
                      </React.Fragment>
                    );
                  })}
              </div>
            )}
            <DayPicker
              selected={highlightedDates?.map((date) => new Date(date))}
              onDayClick={isMainLoading === false && handleDayClick}
              mode="multiple"
              fromYear={
                isMainLoading === false
                  ? moment(highlightedDates?.[0]).format("YYYY")
                  : new Date()
              }
              toYear={
                isMainLoading === false
                  ? moment(
                      highlightedDates?.[highlightedDates?.length - 1]
                    ).format("YYYY")
                  : new Date()
              }
              onMonthChange={(month) => {
                setMonth(month);
                setColorChange((prev) => !prev);
              }}
              id={`deadlines_calender_${details.id}`}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default DeadlinesListSection;
